import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageAnyBookableAsset } from "@/helpers/permissions";
import { canViewSchedule } from "@/modules/bookings/permissions";

import { bookingsRoutes } from "./routes";

export const bookingsRoute = [
  {
    path: bookingsRoutes.list,
    lazy: async () => {
      const { BookableAssetOverviewPage } = await import("./pages/list-assets/BookableAssetOverviewPage");

      return { element: <BookableAssetOverviewPage /> };
    },
  },
  {
    path: bookingsRoutes.assetDetail,
    lazy: async () => {
      const { AssetDetailPage } = await import("./pages/asset-detail/AssetDetailPage");

      return {
        element: (
          <RequireAuth permission={canViewSchedule}>
            <AssetDetailPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: bookingsRoutes.createAsset,
    lazy: async () => {
      const { CreateBookableAssetPage } = await import("./pages/bookable-asset-editor/CreateBookableAssetPage");

      return {
        element: (
          <RequireAuth permission={canManageAnyBookableAsset}>
            <CreateBookableAssetPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: bookingsRoutes.editAsset,
    lazy: async () => {
      const { EditBookableAssetPage } = await import("./pages/bookable-asset-editor/EditBookableAssetPage");

      return {
        element: (
          <RequireAuth permission={canManageAnyBookableAsset}>
            <EditBookableAssetPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: bookingsRoutes.bookAsset,
    lazy: async () => {
      const { CreateBookingPage } = await import("./pages/booking-editor/CreateBookingPage");

      return { element: <CreateBookingPage /> };
    },
  },
  {
    path: bookingsRoutes.editBooking,
    lazy: async () => {
      const { EditBookingPage } = await import("./pages/booking-editor/EditBookingPage");

      return { element: <EditBookingPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
